export default {
  nationalityList: [{
    values: [
      {
        value: '01',
        text: '汉族'
      },
      {
        value: '02',
        text: '蒙古族'
      },
      {
        value: '03',
        text: '回族'
      },
      {
        value: '04',
        text: '藏族'
      },
      {
        value: '05',
        text: '维吾尔族'
      },
      {
        value: '06',
        text: '苗族'
      },
      {
        value: '07',
        text: '彝族'
      },
      {
        value: '08',
        text: '壮族'
      },
      {
        value: '09',
        text: '布依族'
      },
      {
        value: '10',
        text: '朝鲜族'
      },
      {
        value: '11',
        text: '满族'
      },
      {
        value: '12',
        text: '侗族'
      },
      {
        value: '13',
        text: '瑶族'
      },
      {
        value: '14',
        text: '白族'
      },
      {
        value: '15',
        text: '土家族'
      },
      {
        value: '16',
        text: '哈尼族'
      },
      {
        value: '17',
        text: '哈萨克族'
      },
      {
        value: '18',
        text: '傣族'
      },
      {
        value: '19',
        text: '黎族'
      },
      {
        value: '20',
        text: '傈僳族'
      },
      {
        value: '21',
        text: '佤族'
      },
      {
        value: '22',
        text: '畲族'
      },
      {
        value: '23',
        text: '高山族'
      },
      {
        value: '24',
        text: '拉祜族'
      },
      {
        value: '25',
        text: '水族'
      },
      {
        value: '26',
        text: '东乡族'
      },
      {
        value: '27',
        text: '纳西族'
      },
      {
        value: '28',
        text: '景颇族'
      },
      {
        value: '29',
        text: '柯尔克孜族'
      },
      {
        value: '30',
        text: '土族'
      },
      {
        value: '31',
        text: '达斡尔族'
      },
      {
        value: '32',
        text: '仫佬族'
      },
      {
        value: '33',
        text: '羌族'
      },
      {
        value: '34',
        text: '布朗族'
      },
      {
        value: '35',
        text: '撒拉族'
      },
      {
        value: '36',
        text: '毛难族'
      },
      {
        value: '37',
        text: '仡佬族'
      },
      {
        value: '38',
        text: '锡伯族'
      },
      {
        value: '39',
        text: '阿昌族'
      },
      {
        value: '40',
        text: '普米族'
      },
      {
        value: '41',
        text: '塔吉克族'
      },
      {
        value: '42',
        text: '怒族'
      },
      {
        value: '43',
        text: '乌孜别克族'
      },
      {
        value: '44',
        text: '俄罗斯族'
      },
      {
        value: '45',
        text: '鄂温克族'
      },
      {
        value: '46',
        text: '德昂族'
      },
      {
        value: '47',
        text: '保安族'
      },
      {
        value: '48',
        text: '裕固族'
      },
      {
        value: '49',
        text: '京族'
      },
      {
        value: '50',
        text: '塔塔尔族'
      },
      {
        value: '51',
        text: '独龙族'
      },
      {
        value: '52',
        text: '鄂伦春族'
      },
      {
        value: '53',
        text: '赫哲族'
      },
      {
        value: '54',
        text: '门巴族'
      },
      {
        value: '55',
        text: '珞巴族'
      },
      {
        value: '56',
        text: '基诺族'
      },
      {
        value: '98',
        text: '外籍人士'
      }
    ]
  }]
}



// WEBPACK FOOTER //
// ./src/assets/js/nationality.js